import { useState } from 'react'
import { useForm } from 'react-hook-form'

import { logisticFilialsApi } from 'redux/services/logistic-filial'
import { UpdateLogisticFilialStatus } from 'redux/services/logistic-filial/types'

import { AppButton } from 'components/AppButton'
import { AppModal } from 'components/AppModal'
import { TextField } from 'components/TextField'

import { LOGISTIC_FILIAL_STATUS_TEXT } from 'constants/logistic-filial'
import { LogisticFilialStatus } from 'models/logistic-filial'

import styles from './UpdateStatus.module.scss'

const labels: Record<LogisticFilialStatus, string> = {
  [LogisticFilialStatus.in_process]: 'В работу',
  [LogisticFilialStatus.waiting]: 'В ожидание',
  [LogisticFilialStatus.given]: 'Доставленно',
  [LogisticFilialStatus.denied]: 'Отклонить',
  [LogisticFilialStatus.accepted]: 'Карта запрошена',
  [LogisticFilialStatus.for_delivery]: 'Карта на доставке',
  [LogisticFilialStatus.no_accepted]: 'Отказ от доставки',
}

interface Props {
  id: number
  status: LogisticFilialStatus
}
export function UpdateStatus({ id, status }: Props) {
  const [open, setOpen] = useState(false)
  const updateSatusForm = useForm<UpdateLogisticFilialStatus>({
    defaultValues: {
      id,
      body: {
        status,
      },
    },
  })
  const [updateSatus, updateSatusState] =
    logisticFilialsApi.useUpdateLogisticFilialStatusMutation()

  function onSubmitUpdateStatus(values: UpdateLogisticFilialStatus) {
    // if (!values.body.comment) delete values.body.comment

    updateSatus(values)
      .unwrap()
      .then(() => {
        setOpen(false)
      })
  }

  return (
    <>
      <AppButton variant="siren_dashed_border" onClick={() => setOpen(true)}>
        {labels[status]}
      </AppButton>
      {open && (
        <AppModal onClose={() => setOpen(false)} title={`Сменить статус`}>
          <form
            className={styles.container}
            onSubmit={updateSatusForm.handleSubmit(onSubmitUpdateStatus)}
          >
            <TextField
              value={LOGISTIC_FILIAL_STATUS_TEXT[status]}
              disabled
            />

            <>
              <br />

              <TextField
                {...updateSatusForm.register('body.comment')}
                label="Комментарий"
                withError
                error={updateSatusForm.formState.errors.body?.comment?.message}
              />
            </>

            <AppButton disabled={updateSatusState.isLoading} type="submit">
              Принять
            </AppButton>
          </form>
        </AppModal>
      )}
    </>
  )
}
